import React, { useEffect, useState, createContext, useContext } from 'react';
interface EmailContextType {
  email: string;
  setEmail: (email: string) => void;
}
const EmailContext = createContext<EmailContextType | undefined>(undefined);
export const EmailProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  // Try to load email from localStorage or use empty string
  const [email, setEmailState] = useState<string>(() => {
    //const savedEmail = localStorage.getItem('userEmail');
    //return savedEmail || '';
    return '';
  });
  // Save to localStorage whenever email changes
  useEffect(() => {
    if (email) {
      //localStorage.setItem('userEmail', email);
    }
  }, [email]);
  const setEmail = (newEmail: string) => {
    setEmailState(newEmail);
  };
  return <EmailContext.Provider value={{
    email,
    setEmail
  }} data-id="element-2175">
      {children}
    </EmailContext.Provider>;
};
// Custom hook to use the email context
export const useEmail = () => {
  const context = useContext(EmailContext);
  if (context === undefined) {
    throw new Error('useEmail must be used within an EmailProvider');
  }
  return context;
};